import React, {useReducer} from "react"
import ReactGA from "react-ga"

import MainRoutes from "./Routes"

import {StateContext} from "./context/StateProvider"

import reducer, {initialState} from "./context/reducer"

import "./styles/_base.scss"
import "./pages/style.scss"

function App() {
	const [state, dispatch] = useReducer(reducer, initialState)
	//GA for react
	const TRACKING_ID = "G-M5ND15PCV7"
	ReactGA.initialize(TRACKING_ID)
	ReactGA.pageview(window.location.pathname)

	return (
		<div className="app">
			<StateContext.Provider value={{state, dispatch}}>
				<MainRoutes />
			</StateContext.Provider>
		</div>
	)
}

export default App
